import { THealthSecurityIncident, THealthSecurityIncidentAPI } from '@types';

export const apiToIncidentKeyMap: Record<
    keyof THealthSecurityIncidentAPI,
    keyof THealthSecurityIncident
> = {
    id: 'incidentNumber',
    da: 'isoDate',
    co: 'isoCode',
    la: 'latitude',
    lo: 'longitude',
    eC: 'eventCategories',
    tk: 'totalHealthWorkerKilled',
    tK: 'totalHealthWorkerKidnapped',
    ta: 'totalHealthWorkerArrested',
    fd: 'totalHealthFacilitiesDestroyed',
    fD: 'totalHealthFacilitiesDamaged',
    pM: 'perpetratorMap',
    wM: 'weaponUseMap',
    hM: 'healthMeasureMap',
};

const eventCategoryMap: Record<number, string> = {
    1: 'conflictViolence',
    2: 'politicalRelatedViolence',
    3: 'vaccinationRelatedViolence',
    4: 'maternalCareRelatedViolence',
    5: 'outbreakRelatedViolence',
    6: 'droneRelatedViolence',
    7: 'ebolaRelatedViolence',
};

const perpetratorMap: Record<number, string> = {
    1: 'Multiple',
    2: 'Employee',
    3: 'Police',
    4: 'NSA',
    5: 'Vigilante',
    6: 'Patient/family',
    7: 'Protestors',
    8: 'Political party',
    9: 'State military',
    10: 'Criminal',
    11: 'Civilian',
    12: 'No Information',
    13: 'Multiple',
    14: 'Other',
};

const weaponUseMap: Record<number, string> = {
    1: 'Aircraft strikes',
    2: 'Shelling',
    3: 'Drone strikes',
    4: 'Firearms',
    5: 'IEDs and mines',
    6: 'No information',
    7: 'Other',
    8: 'Unspecified explosives',
};

const healthMeasureMap: Record<number, string> = {
    1: 'Objection to hospitals or buildings being used to treat COVID patients',
    2: 'Objection to medical health measures',
    3: 'Objection to public health measures',
    4: 'Speaking out against health management',
    5: 'Way to and from work',
};

export const keyToLookupTable: Record<string, Record<number, string>> = {
    eC: eventCategoryMap,
    pM: perpetratorMap,
    wM: weaponUseMap,
    hM: healthMeasureMap,
};

export const lookupValue = (
    value: number | string,
    lookup: Record<number, string>
): string => {
    return lookup[value] ?? '';
};

export const lookupValueArray = (
    values: number[],
    lookup: Record<number, string>
): string[] => {
    return values.map(value => lookup[value] ?? '');
};

export const incidentAPIDefaults: Partial<THealthSecurityIncident> = {
    latitude: '',
    longitude: '',
    eventCategories: [],
    totalHealthWorkerKilled: '',
    totalHealthWorkerKidnapped: '',
    totalHealthWorkerArrested: '',
    totalHealthFacilitiesDestroyed: '',
    totalHealthFacilitiesDamaged: '',
    perpetratorMap: '',
    weaponUseMap: '',
    healthMeasureMap: '',
};
